import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import DefaultAddress from './DefaultAddress'

const DefaultAddresses = ({ addresses, className }) => (
  <div className={className}>
    <DefaultAddress
      address={addresses.find((address) => address.default_shipping)}
      typeOfAddress="Shipping"
    />
    <DefaultAddress
      address={addresses.find((address) => address.default_billing)}
      typeOfAddress="Billing"
    />
  </div>
)

DefaultAddresses.defaultProps = {
  className: '',
}

DefaultAddresses.propTypes = {
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      default_billing: PropTypes.bool,
      default_shipping: PropTypes.bool,
      id: PropTypes.number,
    }),
  ).isRequired,
  className: PropTypes.string,
}

const StyledDefaultAddresses = styled(DefaultAddresses)({
  display: 'grid',
  gap: '25px',
  gridColumnStart: '1',
  gridColumnEnd: '2',
  gridTemplateColumns: '1fr',
  '.address': {
    marginBottom: '17px',
  },
  '@media(min-width: 600px)': {
    gridColumnEnd: '3',
    gridTemplateColumns: '1fr 1fr',
  },
  '@media(min-width: 1200px)': {
    gridColumnEnd: '4',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
})

export default StyledDefaultAddresses
